import { isDevMode } from "src/config/env";

// TODO: decide if every module should have its own cache
const etagCache = new Map<string, string>();
const isDev = isDevMode();

// For easy debug
if (isDev) {
  (window as unknown as Record<string, unknown>).etagCache = etagCache;
}

export const getEtag = (url: string): string | undefined => etagCache.get(url);

export const setEtag = (url: string, etag: string): void => {
  etagCache.set(url, etag);
};

export const deleteEtag = (url: string): void => {
  etagCache.delete(url);
};

const isMutatingMethod = (method: string | undefined): boolean =>
  method === "put" ||
  method === "patch" ||
  method === "post" ||
  method === "delete";

export const createEtagRequestInterceptor =
  () => (config: import("axios").InternalAxiosRequestConfig) => {
    const { method, url } = config;
    if (isMutatingMethod(method) && url) {
      const etag = getEtag(url);
      if (etag) {
        // eslint-disable-next-line no-param-reassign
        config.headers["If-Match"] = etag;
      }
    }

    return config;
  };

export const createEtagResponseInterceptor =
  () => (response: import("axios").AxiosResponse) => {
    const {
      config: { url },
      headers: { etag },
    } = response;

    if (url && etag) {
      setEtag(url, etag);
    }

    return response;
  };
